import React from "react";

// @ts-expect-error -- untyped module
import errorImage from "@/assets/404-error.svg"; // Adjust the path as necessary

const Error404: React.FC = () => {
  return (
    <div className="flex h-screen w-screen items-center justify-center">
      <div className="flex min-h-screen flex-col items-center justify-center bg-white p-6 text-center">
        <div className="align-ite flex max-w-xl flex-col justify-center gap-4 rounded-lg bg-white p-10" />

        <img src={errorImage} alt="" className="mx-auto mb-6 max-w-64" />
        <h1 className="text-gray-600">Page not found</h1>
      </div>
    </div>
  );
};

export default Error404;
